export const CABIN_RULES = {
  checkedAt:'2026-10-18', liquidContainerMl:100, liquidBagMl:1000,
  batteryApprovalWh:100, batteryUpperWh:160, sparePerPerson:2,
  sourceUrl:'https://business.airport.kr/ap_en/1433/subview.do',
  securityUrl:'https://www.avsec365.or.kr/',
  note:'국제선 액체 기준 후보예요. 국내선·의약품·유아식·면세품은 별도 기준이며 실제 운항사·공항 안내가 우선해요.',
};
